module.exports = __webpack_public_path__ + "static/img/dlbj.f79c4b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dlbj.jpg
// module id = 4fIc
// module chunks = 2